/* eslint-disable max-len */
import React from 'react';
import { object, func, bool, array, string, objectOf, any } from 'prop-types';
import { connect } from 'react-redux';
import { Code } from 'react-content-loader';
import { differenceInDays, parseISO } from 'date-fns';
import get from 'lodash/get';

import Loader from '../../atoms/icons/loader';
import UserModal from '../../molecules/user-modal';
import DmpTracker from '../../atoms/dmp-track';

import { syndicatedSource, checkStoryType } from '../../../helpers/utils';
import { trackClick, trackUserInteraction } from '../../../helpers/datalayer-utils';
import { PATH } from '../../../constants';
import dmpEventsList from '../../../helpers/dmpEventsList';
import Voucherify from '../../../helpers/voucherify-helper';
import MoengageHelper from '../../../helpers/moengage-helper';
import SignupCampaign from '../../../helpers/signup-campaign';

import './micro-payment.m.css';

const btoa = global.btoa || require('btoa');
const { AccessType } = global;
const MAX_DAYS_POST_SUBSCRIPTION = 30;

class PayReadSubscribe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isNewUser: null,
      isLoading: false,
      currentSubscription: null,
      isTrialPlanExpired: false,
      datalayerFields: {
        dimension7: 'NA',
        dimension11: this.props.userLoggedIn ? 'Logged In' : 'Not Logged In',
        dimension12: 'Banner',
        dimension13: 'PPA Hard Paywall',
        dimension14: 'NA',
        dimension15: `${this.props.story.headline}`,
        dimension16: this.props.story['story-template'] || 'text',
        dimension17: this.props.story.sections[0].name,
        dimension18: 'NA',
        dimension19: this.props.story['author-name'],
        dimension20: (this.props.story.tags || []).map((t) => t.name).join(' | '),
        dimension21: syndicatedSource(this.props.story),
        variant: checkStoryType(this.props.story),
      },
    };
    this.payRead = this.payRead.bind(this);
    this.openLoginModal = this.openLoginModal.bind(this);
    this.trackSubscribeClick = this.trackSubscribeClick.bind(this);
    this.trackPpaClick = this.trackPpaClick.bind(this);
    this.goToPayOptionScreen = this.goToPayOptionScreen.bind(this);
    this.openSignUpModal = this.openSignUpModal.bind(this);
  }

  componentDidMount() {
    const { member, story, userLoggedIn } = this.props;
    trackUserInteraction({
      event: 'FunnelEvent',
      category: 'subscription via ppa',
      action: 'pageview',
      label: global.document.title,
      Dimension7: userLoggedIn ? 'Existing' : 'New',
      ...(userLoggedIn && { Dimension8: member.id }),
      Dimension22: 'Banner',
      Dimension23: 'PPA Hard Paywall',
      Dimension24: 'NA',
      Dimension51: story.headline,
      Dimension31: story['story-template'] || 'text',
      Dimension52: story.sections[0].name,
      Dimension02: story['author-name'],
    });
    this.getActivePlan();
    if (this.props.userLoggedIn && this.props.newSubscriptionFlow) {
      Voucherify.updateCustomerMetadata({ hardpaywall: 'yes' });
    }
    SignupCampaign.isTrialPlanExpired()
      .then((response) => {
        this.setState({ isLoading: false });
        response && this.setState({ isTrialPlanExpired: true });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userLoggedIn !== this.props.userLoggedIn) {
      if (this.props.newSubscriptionFlow && this.props.userLoggedIn) {
        Voucherify.updateCustomerMetadata({ hardpaywall: 'yes' });
      }
    }
  }

  openLoginModal() {
    UserModal.open(
      this.goToPayOptionScreen,
      this.props.publicIntegrations,
      this.props.integrations
    );
  }

  openSignUpModal() {
    UserModal.open(
      this.props.reloadMember,
      this.props.publicIntegrations,
      this.props.integrations,
      undefined,
      undefined,
      'SignUp'
    );
  }

  async goToPayOptionScreen(member) {
    await this.props.reloadMember(member);
    this.props.payRead();
  }

  trackSubscribeClick() {
    trackClick([Object.assign({}, this.props.macroPlans, this.state.datalayerFields)]);
  }

  trackPpaClick() {
    trackClick([Object.assign({}, this.props.microPlan, this.state.datalayerFields)]);
  }

  payRead(event) {
    event.preventDefault();
    this.trackPpaClick();
    if (this.props.userLoggedIn) {
      event.target.disbled = true;
      if (this.props.newSubscriptionFlow) {
        const metadata = {
          attempted_PPA: 'yes',
          PPA_attempt_date: new Date().toISOString(),
        };
        Voucherify.updateCustomerMetadata(metadata);
      }
      this.props.payRead();
    } else {
      this.openLoginModal();
    }
  }

  sendDataToDatalayer = (label, CTAId = 'NA') => {
    const { member, story } = this.props;

    const _datalayerFields = {
      event: 'FunnelEvent',
      category: 'subscription via ppa',
      action: 'click',
      label: label,
      Dimension7: member ? 'Existing' : 'New',
      ...(member && { Dimension8: member.id }),
      Dimension22: 'Banner',
      Dimension23: 'PPA Hard Paywall',
      Dimension24: CTAId,
      Dimension51: story.headline,
      Dimension31: story['story-template'] || 'text',
      Dimension52: story.sections[0].name,
      Dimension02: story['author-name'],
    };

    trackUserInteraction(_datalayerFields);
  };

  getActivePlan = () => {
    this.setState({ isLoading: true });
    AccessType &&
      AccessType.getSubscriptions()
        .then((response) => {
          const currentSubscription =
            response.subscriptions.length > 0 ? response.subscriptions[0] : [];

          const isNewUser = !response.subscriptions.filter(
            (subscription) => subscription.subscription_type === 'standard'
          ).length;

          this.setState({
            currentSubscription: currentSubscription,
            isNewUser: isNewUser,
          });
        })
        .catch((e) => {
          console.error(e);
        });
  };

  render() {
    const { datalayerFields, currentSubscription, isLoading } = this.state;
    let showNewMessage = false;
    const gtmParams = btoa(unescape(encodeURIComponent(JSON.stringify(datalayerFields))));
    let subscriptionHeadline = '';
    let subscriptionSummary = 'Subscribe to NDTV Profit for unlimited access at Rs.48 per week.';

    if (this.props.story['access-level-value'] === 999) {
      subscriptionHeadline = `This is an exclusive article only for NDTV Profit subscribers.`;
    } else if (this.props.privateMode) {
      subscriptionHeadline = 'You are using a private or incognito browser mode.';
    } else if (!this.props.userLoggedIn) {
      subscriptionHeadline = 'Continue reading this story';
      subscriptionSummary =
        'You’ve reached your free preview limit for this month. Create an account to continue reading this story at no cost.';
      showNewMessage = true;
    } else {
      subscriptionHeadline = `You have reached your free articles limit.`;
    }
    if (this.props.integrations._30_day_free_trial_plan.enabled && !this.props.userLoggedIn) {
      subscriptionSummary = `Here's your 30-day free access to exclusive NDTV Profit stories powered by insights from Bloomberg.`;
    }
    if (this.props.userLoggedIn && this.state.isTrialPlanExpired) {
      subscriptionSummary = `Your 7-day trial has expired. We hope you loved the NDTV Profit experience. Subscribe now and get upto 30-days extra on your subscription.`;
    }

    const endTimestamp = get(currentSubscription, 'end_timestamp', null);
    const isExpired = get(currentSubscription, 'expired', null);
    const isCancelled = get(currentSubscription, 'cancelled', null);
    const isRecurring = get(currentSubscription, 'recurring', null);
    const diffInDays = differenceInDays(new Date(), parseISO(endTimestamp));
    //  eslint-disable-next-line no-unused-vars
    const isRenewNowVisible =
      !isNaN(diffInDays) && isExpired && diffInDays <= MAX_DAYS_POST_SUBSCRIPTION;

    let buttonText =
      this.props.userLoggedIn && this.state.isTrialPlanExpired
        ? 'Subscribe to NDTV Profit'
        : 'Subscribe';

    const hrefLink = `${this.props.subscribeUrl || PATH.SUBSCRIPTION_PAGE}?gtmParams=${gtmParams}`;

    if (isExpired && !isCancelled && !isRecurring && !this.state.isTrialPlanExpired) {
      buttonText = 'Renew your subscription';
      subscriptionSummary =
        'Your NDTV Profit subscription has expired. Subscribe now and save upto 30% on your subscription.';
    }

    return (
      // <DmpTracker identifier="paywallDmp" eventsList={dmpEventsList}>
      <div styleName="story-subscribe-wrap">
        <div styleName="story-subscribe">
          <h3 styleName="subscribe-headline">{subscriptionHeadline}</h3>
          {isLoading ? (
            <Code height={100} />
          ) : (
            <p styleName="subscribe-summary">{subscriptionSummary}</p>
          )}
          <div styleName="subscribe-buttons">
            {this.props.integrations._30_day_free_trial_plan.enabled && !this.props.userLoggedIn ? (
              <a
                href="/bq-blue-subscription?utm_source=20013"
                target="_blank"
                id="paywallSignUpButton"
                styleName="signup-button"
                onClick={
                  isLoading
                    ? null
                    : () => {
                        global.Moengage && MoengageHelper._30dayfreetrialButtonClicked();
                      }
                }
              >
                SUBSCRIBE FOR 30-DAY FREE TRIAL
              </a>
            ) : (
              <>
                {!showNewMessage ? (
                  isLoading ? (
                    <Loader width="48" color="red" />
                  ) : (
                    <a
                      id="paywallSubscribeButton"
                      dmptrack="true"
                      href={hrefLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      styleName="paywall-button subscribe-btn"
                      onClick={
                        isLoading
                          ? null
                          : () => {
                              this.sendDataToDatalayer(buttonText, '#paywallSubscribeButton');
                              this.trackSubscribeClick();
                              if (
                                this.props.userLoggedIn &&
                                currentSubscription &&
                                currentSubscription.length < 1 &&
                                this.props.integrations._30_day_free_trial_plan.enabled
                              ) {
                                global.Moengage && MoengageHelper._30dayfreetrialButtonClicked();
                              }
                            }
                      }
                    >
                      {buttonText}
                    </a>
                  )
                ) : (
                  <a
                    id="paywallSignUpButton"
                    styleName="signup-button"
                    onClick={() => {
                      this.sendDataToDatalayer('Create an account', '#paywallSignUpButton');
                      this.openSignUpModal();
                    }}
                  >
                    Create an account
                  </a>
                )}
              </>
            )}
          </div>

          <div styleName="subscribe-summary secondary-summary">
            {this.props.integrations._30_day_free_trial_plan.enabled && !this.props.userLoggedIn ? (
              <p>
                <a
                  href={`${
                    this.props.subscribeUrl || PATH.SUBSCRIPTION_PAGE
                  }?gtmParams=${gtmParams}`}
                  styleName="pay-link"
                  onClick={() => {
                    this.sendDataToDatalayer('Explore Plans');
                    this.trackSubscribeClick();
                  }}
                >
                  Explore Plans
                </a>{' '}
                {/* |{' '}
                  <a
                    href="#"
                    styleName="pay-link"
                    onClick={e => {
                      this.sendDataToDatalayer('Buy this article');
                      this.payRead(e);
                    }}
                  >
                    Buy this article at {price}
                  </a> */}
              </p>
            ) : (
              <>
                {!showNewMessage && (
                  <p>
                    Get&nbsp;
                    <a
                      href="/bq-blue-subscription?default_plan=163&referral=BQ10M"
                      styleName="pay-link"
                    >
                      10% OFF
                    </a>{' '}
                    On 12 & 24-month Subscription.
                  </p>
                )}
              </>
            )}
          </div>

          {!showNewMessage && this.props.userLoggedIn !== undefined && !this.props.userLoggedIn && (
            <span styleName="paywall-footer">
              Already a user?{' '}
              <a
                styleName="paywall-footer-link"
                onClick={() => {
                  this.sendDataToDatalayer('Login');
                  this.openLoginModal();
                }}
              >
                Log in.
              </a>
            </span>
          )}
        </div>
      </div>
      // </DmpTracker>
    );
  }
}

PayReadSubscribe.propTypes = {
  payRead: func.isRequired,
  reloadMember: func.isRequired,
  userLoggedIn: bool.isRequired,
  assetPlan: objectOf(any),
  story: objectOf(any).isRequired,
  subscribeUrl: string,
  privateMode: bool.isRequired,
  publicIntegrations: object.isRequired,
  integrations: object.isRequired,
  microPlan: object,
  macroPlans: array,
  newSubscriptionFlow: bool,
  member: object,
};

const mapStateToProps = (state) => {
  const featureConfig = state.qt.config.features;

  return {
    publicIntegrations: state.qt.config['public-integrations'] || {},
    integrations: state.qt.config.integrations || {},
    newSubscriptionFlow: featureConfig.subscription.voucherify_subscription_flow,
    member: state.member,
  };
};

export default connect(mapStateToProps, {})(PayReadSubscribe);
